export const DASHBOARD_REQUEST = 'DASHBOARD_REQUEST';
export const DASHBOARD_SUCCESS = 'DASHBOARD_SUCCESS';
export const DASHBOARD_FAILURE = 'DASHBOARD_FAILURE';

export const SAVE_NOTES_REQUEST = 'SAVE_NOTES_REQUEST';
export const SAVE_NOTES_SUCCESS = 'SAVE_NOTES_SUCCESS';
export const SAVE_NOTES_FAILURE = 'SAVE_NOTES_FAILURE';

export const FETCH_NOTES_REQUEST = 'FETCH_NOTES_REQUEST';
export const FETCH_NOTES_SUCCESS = 'FETCH_NOTES_SUCCESS';
export const FETCH_NOTES_FAILURE = 'FETCH_NOTES_FAILURE';

export const RESET_SAVE_NOTES_SUCCESS = 'RESET_SAVE_NOTES_SUCCESS';
